import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Link, Route, Routes, useLocation } from 'react-router-dom';
import App from './App.tsx';
import StateHubPage from './pages/StateHubPage.tsx';
import NotFoundPage from './pages/NotFoundPage.tsx';
import DraftsPage from './pages/DraftsPage.tsx';
import CheeseJourneyPage from './pages/CheeseJourneyPage.tsx';
import './index.css';

function CheeseJourneyMenuEntry() {
  const location = useLocation();
  if (location.pathname === '/cheese-journey') return null;

  return (
    <>
      <Link
        to="/cheese-journey"
        aria-label="Open the cinematic Cheese Journey"
        className="fixed left-8 top-[390px] z-[75] hidden w-48 items-center gap-3 border-t border-border pt-5 text-sm font-semibold text-ink transition-colors hover:text-accent lg:flex"
      >
        <span className="flex h-5 w-5 items-center justify-center rounded bg-accent text-[10px] text-white">✦</span>
        <span>Cheese Journey</span>
      </Link>
      <Link
        to="/cheese-journey"
        aria-label="Open the cinematic Cheese Journey"
        className="fixed right-16 top-[22px] z-[75] rounded-full border border-border bg-white/90 px-3 py-2 text-[9px] font-bold uppercase tracking-[0.12em] text-ink shadow-sm backdrop-blur transition-colors hover:border-accent hover:text-accent lg:hidden"
      >
        ✦ Journey
      </Link>
    </>
  );
}

/**
 * Route table.
 *
 * - `/`, `/map`, `/trails`, `/cheeses`, `/stays`, `/plan` render the main app.
 * - `/cheese-journey` is an isolated cinematic React page using the same SPA
 *   fallback as the rest of the site.
 * - State trail routes remain standalone editorial chapters.
 */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <CheeseJourneyMenuEntry />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/map" element={<App />} />
        <Route path="/trails" element={<App />} />
        <Route path="/cheeses" element={<App />} />
        <Route path="/stays" element={<App />} />
        <Route path="/plan" element={<App />} />
        <Route path="/cheese-journey" element={<CheeseJourneyPage />} />
        <Route path="/vermont-cheese-trail" element={<StateHubPage state="VT" />} />
        <Route path="/maine-cheese-trail" element={<StateHubPage state="ME" />} />
        <Route path="/new-hampshire-cheese-trail" element={<StateHubPage state="NH" />} />
        <Route path="/drafts" element={<DraftsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
